var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SelectButton',{attrs:{"name":"switch-amount-quantity","options":_vm.options,"optionLabel":"text","optionValue":"value"},model:{value:(_vm.localSwitchAmountQuantity),callback:function ($$v) {_vm.localSwitchAmountQuantity=$$v},expression:"localSwitchAmountQuantity"}})
}
var staticRenderFns = []

export { render, staticRenderFns }